/* Keep both professional-header badges in sync with the active Shopify cart. */
(() => {
  const badges = () => document.querySelectorAll('.wbg-nav [data-wbg-cart-count]');
  const render = (count) => {
    const quantity = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;
    badges().forEach((badge) => {
      badge.textContent = String(quantity);
      badge.hidden = quantity === 0;
    });
  };
  let requestId = 0;
  const refresh = async () => {
    const id = ++requestId;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (id === requestId && Number.isFinite(Number(cart.item_count))) render(cart.item_count);
    } catch (_) {
      /* Retain the server-rendered badge if the cart endpoint is unavailable. */
    }
  };
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:update', refresh);
  document.addEventListener('cart:change', refresh);
  document.addEventListener('cart:empty', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:cart:lines-update', refresh);
})();
